// @flow

import React from 'react';
import { Spinner } from '@shopify/polaris';
import Classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

export const Switch = ({
  id,
  disabled,
  label,
  icon,
  value,
  tooltip,
  onChange,
  size = 'large',
  loading = false,
  tooltipOptions = {
    placeTooltip: 'bottom',
    effectTooltip: 'solid',
    overridePosition: ({ left, top }) => ({ left, top })
  }
}) => {
  const handleToggle = e => {
    onChange(e.target.checked);
  };

  return (
    <div className="BC-Toggle-Switch-Button">
      {loading ? (
        <div
          style={{
            minWidth: '34px',
            marginRight: '8px',
            display: 'inline-flex',
            justifyContent: 'center'
          }}>
          <Spinner size="small" />
        </div>
      ) : (
        <label
          className={Classnames('BC-Switch-Status', {
            'BC-Switch-Status--small': size === 'small'
          })}
          data-for={id}
          data-tip={tooltip}>
          <input
            id={id}
            type="checkbox"
            disabled={disabled}
            checked={value ? true : false}
            onChange={handleToggle}
          />
          <div
            className="BC-Switch-Status__Bar"
            style={{ cursor: disabled ? 'default' : 'pointer' }}>
            <div className="BC-Switch-Status__Dot">{icon}</div>
          </div>
        </label>
      )}

      {/* Render label */}
      {label && (
        <div style={{ width: 'fit-content' }}>
          <div className="Polaris-Labelled__LabelWrapper">
            <div className="Polaris-Label">
              <label
                style={{ display: 'inline', color: disabled ? '#8C9196' : '' }}
                className={`Polaris-Label__Text ${disabled ? 'disabled' : ''}`}>
                {label}
              </label>
            </div>
          </div>
        </div>
      )}

      <ReactTooltip
        id={id}
        place={tooltipOptions?.placeTooltip}
        effect={tooltipOptions?.effectTooltip}
        overridePosition={tooltipOptions?.overridePosition}
        type="light"
      />
    </div>
  );
};
